module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-07-4b40a144c60391c4a0ccc90d2d4514e6.jpg";